import { ApiRouteDefinition } from '@auth0/auth0-angular';
import { environment } from '../environments/environment';

export const REGISTERED_ONLY_ROUTES: ApiRouteDefinition[] = [
  {
    allowAnonymous: true,
    uri: 'https://....'
  },
  `${environment.api.url}/projects*`,
  `${environment.api.url}/countries*`,
  `${environment.api.url}/users*`,
  `${environment.api.url}/dashboard*`
];
